import DOMPurify from 'dompurify';

export default function sanitize(content) {
  return DOMPurify.sanitize(content);
}
